import { supabase } from './supabaseClient';

function mapCartItemsForOrder(cartItems) {
  return cartItems.map(item => ({
    product_id: item.id,
    product_name: item.name,
    price: Number(item.price),
    quantity: Number(item.quantity) || 1,
    image_url: item.image_url || null,
    size_label: item.size || null,
  }));
}

function extractRpcErrorMessage(error) {
  const raw = error?.message || error?.details || error?.hint || '';
  const match = raw.match(
    /(?:Only \d+ left in stock[^.]*\.|Size [^.]+\.|Size is required[^.]*\.|Stock changed[^.]*\.|Cart is empty\.|You must be signed in[^.]*\.|Shipping details are incomplete\.|Invalid [^.]+\.)/i
  );
  if (match) return match[0].trim();
  if (raw && !/rpc|function|schema cache|place_order/i.test(raw)) {
    return raw;
  }
  return '';
}

export async function createOrder({ cartItems, totalPrice, shipping }) {
  const items = mapCartItemsForOrder(cartItems);

  const { data: orderId, error: rpcError } = await supabase.rpc('place_order', {
    p_items: items,
    p_total: totalPrice,
    p_shipping: {
      name: shipping.name,
      email: shipping.email,
      address: shipping.address,
      city: shipping.city,
      zip: shipping.zip,
    },
  });

  if (!rpcError && orderId) {
    return orderId;
  }

  if (rpcError && /could not find|does not exist|schema cache|function/i.test(rpcError.message || '')) {
    throw new Error(
      'Stock checkout is not set up yet. Run supabase-stock-checkout.sql in the Supabase SQL Editor, then try again.'
    );
  }

  const friendly = extractRpcErrorMessage(rpcError);
  throw new Error(friendly || rpcError?.message || 'Could not place your order.');
}

export async function fetchUserOrders(userId) {
  const { data: orders, error: ordersError } = await supabase
    .from('orders')
    .select(`
      id,
      status,
      total,
      shipping_name,
      shipping_email,
      shipping_address,
      shipping_city,
      shipping_zip,
      created_at,
      order_items (
        id,
        product_name,
        price,
        quantity,
        image_url,
        size_label
      )
    `)
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (ordersError) {
    if (/size_label/i.test(ordersError.message || '')) {
      const { data, error } = await supabase
        .from('orders')
        .select(`
          id,
          status,
          total,
          shipping_name,
          shipping_email,
          shipping_address,
          shipping_city,
          shipping_zip,
          created_at,
          order_items (
            id,
            product_name,
            price,
            quantity,
            image_url
          )
        `)
        .eq('user_id', userId)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    }

    throw ordersError;
  }

  return orders || [];
}
